import { render, staticRenderFns } from "./TransportTypeSelector.vue?vue&type=template&id=1f49558f&"
import script from "./TransportTypeSelector.vue?vue&type=script&lang=js&"
export * from "./TransportTypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports